import { Component, Input, OnInit } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LocalizationService, LocalizedNumberFormat } from 'src/app/shared/localization/localization.service';
import { CasesService } from 'src/app/services/cases.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MessageToUiService } from 'src/app/services/message-to-ui.service';
import { GlobalSpinnerService } from 'src/app/shared/global-spinner/global-spinner.service';

@Component({
  selector: 'app-withdraw-case',
  imports: [CommonModule, TranslateModule, MatDialogModule, MatProgressBarModule, FormsModule],
  providers: [DecimalPipe],
  templateUrl: './withdraw-case.component.html',
  styleUrls: ['./withdraw-case.component.scss']
})
export class WithdrawCaseComponent implements OnInit {
  numberFormat: LocalizedNumberFormat;

  constructor(
    private localization: LocalizationService,
    private service: CasesService,
    private dialogRef: MatDialogRef<any>,
    private notification: MessageToUiService,
    private translateService: TranslateService,
    private decimalPipe: DecimalPipe,
    private spinner: GlobalSpinnerService
  ) { }

  @Input() caseNumber: number;

  agreementTerms$: Observable<string>;
  reason: string;

  get canAccept(): boolean {
    return this.reason && this.reason.trim().length > 0;
  }

  private _terms: string;

  ngOnInit(): void {
    this.localization.settings$.subscribe(_ => this.numberFormat = _.numberPipeFormat);

    this.agreementTerms$ = this.service.getWithdrawCost(this.caseNumber)
      .pipe(
        map(_ => {
          this._terms = `${this.translateService.instant('WithdrawCaseDialog.WithdowCaseInfo',
              { currency: this.localization.getFirmCurrencyCode(), amount: this.decimalPipe.transform(_.totalCosts, this.numberFormat.style, this.numberFormat.culture)})}:`;
          return this._terms;
          })
        , catchError(e => { this.onLoadTermsError(); return of('') }));
  }

  acceptAggreementTerms() {
    this.spinner.show();
    const termsAndReason = this._terms + '\nReason: ' + this.reason;

    this.service.sendWithdrawCaseRequest(this.caseNumber, termsAndReason)
      .subscribe({
          next: () => this.dialogRef?.close(true)
        , error: () => this.notification.genericError()
        , complete: () => this.spinner.hide()
      });
  }

  onLoadTermsError() {
    this.notification.genericError();
    this.cancel();
  }

  cancel() {
    this.reason = undefined;
    this.dialogRef?.close(false);
  }
}
